import View from 'ol/View';
import Map from 'ol/Map';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { bindSelect } from './utils';
import { debounce } from './utils';
import Point from 'ol/geom/Point';


export function setupUI(state) {
    const latUI = document.getElementById("lat");
    const lonUI = document.getElementById("lon");
    const menuUI = document.getElementById('menu');
    const jumpUI = document.getElementById("jump");
    const kmlUI = document.getElementById("kml-select");
    const treeGapUI = document.getElementById('treeGap');
    const rowGapUI = document.getElementById('rowGap');
    const aUI = document.getElementById("A");
    const bUI = document.getElementById("B");


    // have the bgcolor reflect if a fix is on or off
    state.onFix(fix => {
        if (fix) {
            latUI.style.backgroundColor = lonUI.style.backgroundColor = '#FFFFCC';
        } else {
            latUI.style.backgroundColor = lonUI.style.backgroundColor = '#FFFFFF';
        }
    })

    state.onGps((value, oldValue) => {
        if (oldValue) {
            var d = Math.sqrt((oldValue[0] - value[0]) ** 2 + (oldValue[1] - value[1]) ** 2);
            if (d < 100) jumpUI.value = d;
            else jumpUI.value = '+++';
        }
    })

    // state follow ui and ui follow state
    state.onTreeGap(value => treeGapUI.value = value);
    treeGapUI.addEventListener('change', debounce(
        event => {
            state.treeGap = parseFloat(event.target.value)
        }
        , 200));

    state.onRowGap(value => rowGapUI.value = value);
    rowGapUI.addEventListener('change', debounce(event => state.rowGap = parseFloat(event.target.value), 200));

    // state follow UI
    aUI.addEventListener('click', event => state.a = state.centerAt);

    bUI.addEventListener('click', event => state.b = state.centerAt);

    state.onCenterAt(value => {
        var coords = new Point(value).transform('EPSG:3857', state.epsg).getCoordinates();
        latUI.value = Number(coords[1]).toFixed(8);
        lonUI.value = Number(coords[0]).toFixed(8);
    });

    state.onEpsg(value => {
        let cat = state.centerAt;
        if(cat) state.centerAt = [cat[0], cat[1]]; // poke it so it updates the ui
    })

    kmlUI.addEventListener('change', event => {
        state.kml = kmlUI.options[kmlUI.selectedIndex].value;
    });

    bindSelect(menuUI, state);

}

